import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Full-height mobile-app layout. Navigation is handled entirely by the
 * top-right MenuButton + MenuDrawer on each screen (bottom tab bar removed
 * per user request).
 */
export default function MobileShell() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/auth", { replace: true });
    }
  }, [loading, user, navigate]);

  return (
    <div
      className="min-h-screen bg-background"
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      <main data-testid="mobile-app-root">
        <Outlet />
      </main>
    </div>
  );
}
